<div class="title">Offer Saved</div>

<div class="subtitle">
  <span>A draft of the offer has been saved!</span>
  <span>You may continue to edit it at anytime. Change the status</span>
  <span>of the draft to manually track it in the system.</span>
</div>

<div class="actions">
  <button (click)="viewOffer()" mat-flat-button color="primary">View Offer</button>
  <button mat-dialog-close mat-flat-button>Continue Editing</button>
  <button (click)="openDashboard()" mat-flat-button>Back to Dashboard</button>
</div>